import { api } from "../../App";
import { getObjectFromArray } from "../../utils/smallHelpers";
import { SET_SETTINGS_CONTROL_DATA, SET_SETTINGS_KIOSK_DATA, SET_SETTINGS_KIOSK_VIDEO_DATA, SET_SETTINGS_LOADING } from "../types";
import { createNotification } from "../../components/Notifications/Notifications";



export const getKioskData = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_SETTINGS_LOADING, payload: true });
    const { data } = await api.get('/kiosk_options')
    const payload = getObjectFromArray(data.options)
    dispatch({ type: SET_SETTINGS_KIOSK_DATA, payload })

  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_SETTINGS_LOADING, payload: false });
  }
};

export const getKioskVideoData = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_SETTINGS_LOADING, payload: true });
    const { data } = await api.get('/kiosk_options/video_list')
    const payload = getObjectFromArray(data.options)
    dispatch({ type: SET_SETTINGS_KIOSK_VIDEO_DATA, payload: data.video_list })

  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_SETTINGS_LOADING, payload: false });
  }
};

export const updateKioskVideo = (values) => async (dispatch) => {
  try {
    dispatch({ type: SET_SETTINGS_LOADING, payload: true });
    await api.put('/kiosk_options/video_list', values)
    dispatch(getKioskVideoData())
    createNotification('success', 'Сохранено')
  } catch (ERR) {
    console.log(ERR)
    createNotification('error', 'Ошибка сохранения')
  } finally {
    dispatch({ type: SET_SETTINGS_LOADING, payload: false });
  }
};

export const uploadKioskVideo = (file) => async (dispatch) => {
  try {
    dispatch({ type: SET_SETTINGS_LOADING, payload: true });
    const formData = new FormData();
    formData.append('file', file);
    await api.post('/kiosk_options/video_list', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    dispatch(getKioskVideoData())
    createNotification('success', 'Файл загружен')
  } catch (ERR) {
    console.log(ERR)
    createNotification('error', 'Ошибка загрузки файла')
  } finally {
    dispatch({ type: SET_SETTINGS_LOADING, payload: false });
  }
};

export const deleteKioskVideo = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_SETTINGS_LOADING, payload: true });
    await api.delete(`/kiosk_options/video_list/${id}`)
    dispatch(getKioskVideoData())
    createNotification('success', 'Удалено')
  } catch (ERR) {
    console.log(ERR)
    createNotification('error', 'Ошибка удаления')
  } finally {
    dispatch({ type: SET_SETTINGS_LOADING, payload: false });
  }
};